/* unplugin-vue-components disabled */import script from "./sidenavList.vue?vue&type=script&setup=true&lang=js"
export * from "./sidenavList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__